import { render, staticRenderFns } from "./QcqQualification.vue?vue&type=template&id=3f2aa962&scoped=true&lang=pug&"
import script from "./QcqQualification.vue?vue&type=script&lang=ts&"
export * from "./QcqQualification.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2aa962",
  null
  
)

export default component.exports